import React from 'react'
import Sidebar from '../Global/Sidebar.js'
import Feed from '../Home/Feed'
import Searchbar from '../Global/Searchbar'

class Content extends React.Component {
	render() {

		const { pathname } = this.props

		return (
			<section className="content height-x">
				<div className="container">
					<div className="row">
						<div className="col-12 col-lg-2">
							<Sidebar pathname={ pathname } />
						</div>
						<div className="col-12 col-lg-3 push-lg-7">
							<Searchbar />
						</div>
						<div className="col-12 col-lg-7 pull-lg-3">
							<Feed feed={ "popular" } onLogin={ this.props.onLogin } />
							<Feed feed={ "newest" } onLogin={ this.props.onLogin } />
							<Feed feed={ "featured" } onLogin={ this.props.onLogin } />
						</div>
					</div>
				</div>
			</section>
		)
	}
}

export default Content



// WEBPACK FOOTER //
// ./src/components/Home/Content.js